import KadChartist from 'libs/kad-chartist';
const AdminTermListingVM = function(data) {
  var self = this;

  self.$el = $('#admin_terms_listing');
  self.$terms_modal = $('#terms_modal');
  self.terms = ko.observableArray();

  self.term_model = {
    id: ko.observable(),
    is_locked: ko.observable(),
    name: ko.observable().extend({ required: true }),
    start_date_string: ko.observable().extend({ required: true }),
    end_date_string: ko.observable().extend({ required: true })
  };

  self.selected_term = ko.observable(self.term_model);

  self.bindData = function(data) {
    var mapping = {
      'is_locked': {
        create: function(options) {
          return ko.observable(!options.data ? false : options.data);
        }
      },

      'start_date_string': {
        create: function(options) {
          return ko.observable(!options.data ? 'N/A' : options.data);
        }
      },

      'end_date_string': {
        create: function(options) {
          return ko.observable(!options.data ? 'N/A' : options.data);
        }
      }
    };

    var mapped_terms = ko.mapping.fromJS(data.terms, mapping),
      CoursesBarData = self.parseChartData(data.terms, { seriesName: 'Courses', dataPoint: 'course_count'  }),
      StudentBarData = self.parseChartData(data.terms, { seriesName: 'Students', dataPoint: 'student_count'  }),
      chartOption = {
        showArea: false,
        onlyInteger: true,
        axisX: {
          offset: 15,
          labelPadding: 10
        },
        axisY: {
          offset: 15
        },
        lineSmooth: Chartist.Interpolation.none(),
        chartPadding: {
          top: 20,
          right: 10,
          bottom: 65,
          left: 40
        }
      },
      barChart = new KadChartist.Chart(
        '.js-chart-bar',
        {
          data: CoursesBarData,
          chartistOptions: chartOption,
          truncateLabels: true
        }
      ),
      barChart2 = new KadChartist.Chart(
        '.js-chart-bar-2',
        {
          data: StudentBarData,
          chartistOptions: chartOption,
          truncateLabels: true
        }
      );
    self.terms(mapped_terms());
  };

  self.resetSelected = function() {
    self.client_errors = ko.validation.group(self.selected_term(), { deep: true });
    self.selected_term(self.term_model);

    self.client_errors.showAllMessages(false);
  };

  self.parseChartData = function(data, params) {
    var chartData = {
      labels: data.map(item => item.name),
      series: [
        {
          name: params.seriesName,
          data: data.map(item => item[params.dataPoint])
        }
      ]
    };

    return chartData;
  };

  /*--------------------------------------TERM STATE MANAGEMENT FUNCTIONS-----------------------------------------*/

  self.new = function() {
    self.selected_term(self.term_model);
    self.$terms_modal.modal('show');
  };

  self.add = function(item, event) {
    if(!self.validate()) return;

    self.$terms_modal.modal('hide');

    var request = new Kadenze.AjaxRequest({
      url: Kadenze.Routes.admin_terms_path(),
      data: { term: ko.mapping.toJS(self.selected_term()) },
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(self.addSuccess);
    request.fail(self.fail);
  };

  self.edit = function(item, event) {
    if(item.is_locked()) return;

    self.selected_term(item);
    self.$terms_modal.modal('show');
  };

  self.update = function(item, event) {
    if(!self.validate()) return;

    self.$terms_modal.modal('hide');
    var data = ko.mapping.toJS(self.selected_term());

    data.start_date_string = self.selected_term().start_date_string();
    data.end_date_string = self.selected_term().end_date_string();

    var request = new Kadenze.AjaxRequest({
      type: 'PATCH',
      url: Kadenze.Routes.admin_term_path(self.selected_term().id()),
      data: { term: data },
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(self.success);
    request.fail(self.fail);
  };

  self.delete = function(item, event) {
    var deletePrompt = 'Are you sure you want to delete this term and its course associations?',
      term = item.isA(AdminTermListingVM) ? item.selected_term() : item;

    if(term.is_locked()) return;

    Kadenze.UIUtil.confirmAction(deletePrompt, function() {

      var request = new Kadenze.AjaxRequest({
        type: 'DELETE',
        url: Kadenze.Routes.admin_term_path(term.id()),
        loadingIndicator: {
          container: self.$el
        }
      });

      request.done(function(data) {
        self.$terms_modal.modal('hide');
        self.terms.remove(term);
        self.success(data);
      });

      request.fail(self.fail);
    });
  };

  self.toggleLocked = function(term, event) {
    var request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: '/admin/terms/' + term.id() + '/lock', // TODO use Kadenze.Routes, figure out why route isn't generated
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function(data) {
      term.is_locked(!term.is_locked());
      self.success(data);
    });

    request.fail(self.fail);
  };


  self.addSuccess = function(data) {
    var formatted_start_date = moment(data.term.start_date).format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    var formatted_end_date = moment(data.term.end_date).format(Kadenze.I18n.t('date.formats.js_default_with_zone'));
    var mapped_term = ko.mapping.fromJS($.extend(data.term, { course_count: 0, start_date_string: formatted_start_date, end_date_string: formatted_end_date}));

    self.terms.push(mapped_term);
    self.success(data);
  };

  self.fail = function(data) {
    console.warn('Failed to save term:', data);
    new Kadenze.Notice.error({ message: data.responseJSON.message });
  };

  self.success = function(data) {
    self.resetSelected();
    new Kadenze.Notice.success({ message: data.message });
  };

  self.validate = function() {
    self.client_errors = ko.validation.group(self.selected_term(), { deep: true });

    if(self.client_errors().length > 0) {
      self.client_errors.showAllMessages();

      return false;
    } else {
      return true;
    }
  };

  const __construct = function(that) {
    console.log('constructor called for AdminTermsListingViewModel');
    that.bindData(data);
  }(this);
};

export default AdminTermListingVM;
